import ButtonGroup from '@atlaskit/button/button-group';
import Button from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import { Flex, Stack, Text } from '@atlaskit/primitives';
import { useIntl } from 'react-intl-next';

import { useSetCodePlannerSettingsController } from '../hooks/use-set-code-planner-settings-controller';
import type { JiraProject } from '../types';

import messages from './messages';
import { siteName } from './types';

type SiteSettingsProps = {
	projects: JiraProject[];
	onChange: (settings: Map<string, boolean>) => void;
};

export const SiteSettings = ({ projects, onChange }: SiteSettingsProps) => {
	const { setCodePlannerSettings } = useSetCodePlannerSettingsController();
	const { formatMessage } = useIntl();

	const handleEnable = () => {
		onChange(new Map(projects.map((project) => [project.id, true])));
		setCodePlannerSettings(
			projects.map((project) => ({
				containerId: project.id,
				value: true,
			})),
		);
	};

	const handleDisable = () => {
		onChange(new Map(projects.map((project) => [project.id, false])));
		setCodePlannerSettings(
			projects.map((project) => ({
				containerId: project.id,
				value: false,
			})),
		);
	};

	return (
		<Stack testId="site-settings" space="space.150">
			<Heading as="h3" size="small">
				{formatMessage(messages.siteSettingsTitle)}
			</Heading>
			<Text>{formatMessage(messages.siteSettingsDescription, { siteName })}</Text>
			<Flex>
				<ButtonGroup label={formatMessage(messages.toggleAllReposButtonGroupTitle)}>
					<Button onClick={handleEnable}>
						{formatMessage(messages.enableAllReposButtonTitle)}
					</Button>
					<Button onClick={handleDisable}>
						{formatMessage(messages.disableAllReposButtonTitle)}
					</Button>
				</ButtonGroup>
			</Flex>
		</Stack>
	);
};
